import Layout from '@/layouts/index'
import BasicLayout from '@/layouts/basic-layout.vue'
export default [
  {
    path: '/',
    name: 'home',
    component: Layout,
    children: [
      {
        path: '/noActive',
        name: 'noActive',
        component: () => import('@/views/403.vue'),
        meta: { title: '欢迎' }
      },
      {
        path: '/developing',
        name: 'developing',
        component: () => import('@/views/Developing.vue'),
        meta: { title: '开发中' }
      },
      {
        path: '/s/*',
        name: 'subApp',
        component: () => import('@/views/SubApp/index.vue'),
        meta: {
          title: '',
          keep: true,
        },
      },
      {
        path: '/sub-app/*',
        name: 'subApp-old',
        redirect: to => {
          // 方法接收 目标路由 作为参数
          // return 重定向的 字符串路径/路径对象
          return to.fullPath.replace('/sub-app/', '/s/')
        }
      },
      {
        path: '/',
        name: 'subAppHome',
        redirect: '/s/erp/'
      },
    ]
  },
  {
    path: '/user',
    name: 'user',
    component: BasicLayout,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/User/Login.vue'),
        meta: { title: '登录' }
      },
      {
        path: 'register',
        name: 'register',
        component: () => import('@/views/User/Register.vue'),
        meta: { title: '注册' }
      },
      {
        path: 'forgetpwd',
        name: 'forgetpwd',
        component: () => import('@/views/User/ForgetPwd.vue'),
        meta: { title: '忘记密码' }
      },
      {
        path: 'passwd',
        name: 'passwd',
        component: () => import('@/views/User/Passwd.vue'),
        meta: { title: '修改密码' }
      },
      {
        path: 'privacy-policy',
        name: 'privacyPolicy',
        component: () => import('@/views/User/PrivacyPolicy.vue'),
        meta: { title: '隐私条款' }
      },
      {
        path: 'standalone-register',
        name: 'standalone-register',
        component: () => import('@/views/User/StandaloneRegister.vue'),
        meta: { title: '注册' }
      },
      {
        path: 'standalone-entry',
        name: 'standalone-entry',
        component: () => import('@/views/User/StandaloneEntry.vue'),
        meta: { title: '体验版' }
      },
      {
        path: 'registry-success',
        name: 'registry-success',
        component: () => import('@/views/User/RegistrySuccess.vue'),
        meta: { title: '注册成功页' }
      },
      {
        path: 'promotional-page',
        name: 'promotional-page',
        component: () => import('@/views/User/PromotionalPage.vue'),
        meta: { title: '进销存+运营+财务一体化管理专家' }
      },
    ]
  },
]
